import React, { Fragment } from 'react';

import { Margin, Surface, Text } from '@zapier/design-system';

import GettingReady from './GettingReady';
import Timeline from './Timeline';
import { BetaChecklist } from './BetaChecklist';
import { PublishingSteps, Status } from './PublishingSteps';

type Props = {
  integrationId: number;
  integrationName: string;
  status: Status;
};

export default function LaunchProgress({
  integrationId,
  integrationName,
  status,
}: Props) {
  const stepIndex = PublishingSteps.findIndex(s => s.status === status);
  const step = PublishingSteps[stepIndex] || null;

  return (
    <Surface borderColor="GrayWarm4">
      <Margin margin="20px">
        <Text margin="1em 0" tag="p" textAlign="center" type="SectionHeader">
          Launch Progress
        </Text>
        <Timeline currentStep={step} />
        {step && stepIndex < PublishingSteps.length - 1 && (
          <Fragment>
            <BetaChecklist
              currentStatus={step.status}
              integrationId={integrationId}
            />
            <GettingReady
              currentStatus={step.status}
              integrationId={integrationId}
              integrationName={integrationName}
              step={PublishingSteps[stepIndex + 1]}
            />
          </Fragment>
        )}
      </Margin>
    </Surface>
  );
}
